import { DEFAULT_FILE_BLEED } from "@pdfking/constants/settings"
import items from "rfuncs/functions/items"
import length from "rfuncs/functions/length"
import map from "rfuncs/functions/map"
import merge from "rfuncs/functions/merge"
import object_map from "rfuncs/functions/object_map"
import scan from "rfuncs/functions/scan"

import get_imposition_data from "../../actions/utils/get_imposition_dispatch_data"
import plot_from_context from "./plot_from_context"

export default async function* plot_media_pdf(generator) {
  for await (const [url, used_pages, page_numbers] of generator) {
    const context = await get_imposition_data(url)
    let t = 0
    context.meta.layers = {
      file: {
        printable: true,
      },
    }
    context.meta.templates = {}
    const page_to_plot = {}
    const template_id = (t, i) => `${t}-${i}`
    scan((numbers, k) => {
      t += 1
      let offset = 0
      const pages = map(
        n =>
          merge(context.meta.media[n - 1], {
            n,
          }),
        numbers
      )
      scan((page, n) => {
        const is_first = n == 0
        const is_last = n + 1 == length(pages)
        context.meta.templates[template_id(t, n)] = {
          file: [
            {
              func: "plot_media",
              crop_position: [
                offset + (is_first ? -DEFAULT_FILE_BLEED : 0),
                -DEFAULT_FILE_BLEED,
                offset + page.width + (is_last ? DEFAULT_FILE_BLEED : 0),
                page.height + DEFAULT_FILE_BLEED,
              ],
              rotation: 0,
              media_position: [offset, 0, offset + page.width, page.height],
              page: template_id(t, n),
              layer: "file",
            },
          ],
        }
        offset += page.width
      }, pages)
      page_to_plot[k] = {
        templates: map((p, n) => template_id(t, n), pages),
        pages: object_map(
          (p, n) => template_id(t, n),
          p => p.n,
          pages
        ),
        position: [
          0,
          0,
          map(p => p.width, pages).reduce((a, b) => a + b, 0),
          Math.max(...map(p => p.height, pages)),
        ],
        bleed: DEFAULT_FILE_BLEED,
      }
    }, page_numbers)

    // alternative to the loop
    // yield {url: await plot_from_context({ context, used_pages }, ...opts), page: 1}

    const total = length(page_to_plot)

    for (const [k, p] of items(page_to_plot)) {
      for await (const info of plot_from_context({
        context: merge(context, {
          pages: [p],
        }),
        used_pages,
      })) {
        yield {
          ...info,
          page: parseInt(k),
          total,
        }
      }
    }
  }
}
